/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { ControlTable } from "../../../components/Table";
import useForm from "../../../hooks/useForm";
import Filters from "../../../components/Filters";
import { getAccountingTitleList } from "../../../apis/finances/accounting-title";
import { getParams } from "../../../utils/params";
import CategoryModal from "./CategoryModal";
import { CATEGORY_SEARCH_OPTIONS } from "../../../constants/CATEGORY";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import { isEmpty } from "lodash";
import { permissionCheck } from "../../../utils/permission";

const CategoryList = (props) => {
  const history = useHistory()
  const { permissions } = useSelector(
    (store) => ({
      permissions: store.Profile.permissions,
    }),
  );
  const [fields] = useState([
    { title: '카테고리명', key: 'name' },
    { title: "계정체계", key: "class" },
    { title: "코드", key: "code" },
    { title: "성격", key: "kind" },
    { title: "관계 카테고리 코드", key: "refCode" },
    {
      title: "수정여부", key: "editable", onTranslator: {
        list: [
          { label: '가능', value: true },
          { label: '불가능', value: false }
        ]
      }
    },
  ])
  const [filters] = useState([
    {
      title: "분류 선택",
      type: "select",
      key: "searchType",
      options: {
        list: CATEGORY_SEARCH_OPTIONS,
      },
    },
    {
      title: "키워드 검색",
      type: "input",
      key: "searchText",
      options: {
        placeholder: "검색어 입력",
      },
    },
  ])
  const [detailOpen, setDetailOpen] = useState(false)
  const [selectedItem, setSelectedItem] = useState(null)
  const [targetPermission, setTargetPermission] = useState(null)

  useEffect(() => {
    if (!isEmpty(permissions))
    {
      const permission = permissions.find(p => p.code === 'FUND_CLAIM_OBLIGATION')
      setTargetPermission(permission)
      if (isEmpty(permission))
      {
        permissionCheck(history, "FUND_CLAIM_OBLIGATION")
      }
    }
  }, [permissions])

  const {
    form,
    setSubmit,
    handleOnChange,
    handleSubmit,
    // LIST 용
    filterSubmit,
    list, setList,
    isLoading, setIsLoading,
    total, setTotal,
    page, setPage,
    limit, setLimit,
  } = useForm(
    {
      searchType: 'name',
      searchText: '',
      page: 0,
      limit: 10
    },
  )

  useEffect(() => {
    submit(form);
    setSubmit(submit)
  }, [])

  const rowBtnConfig = {
    title: '카테고리명 수정',
    rowButtons: [
      {
        isHide: (data) => { return !(data.editable) },
        label: "수정",
        type: "edit",
        action: (data) => {
          setDetailOpen(true)
          setSelectedItem(data)
        },
      },
    ],
  };

  const submit = (_params) => {
    setIsLoading(true)
    getAccountingTitleList(getParams(_params))
      .then((res) => {
        setList(res.data.accountingTitles)
        setTotal(res.data.totalCount)
      })
      .catch(() => { })
      .finally(() => {
        setIsLoading(false)
      })
  }

  return (
    !isEmpty(targetPermission) && (
      <>
        <Filters
          isLoading={isLoading}
          filters={filters}
          submit={filterSubmit}
          form={form}
          onChange={handleOnChange}
        />
        <ControlTable
          fields={fields}
          list={list}
          isLoading={isLoading}
          total={total}
          page={page}
          setPage={setPage}
          limit={limit}
          setLimit={setLimit}
          submit={handleSubmit}
          rowBtn={rowBtnConfig}
        />
        <CategoryModal
          open={detailOpen}
          setOpen={setDetailOpen}
          submit={filterSubmit}
          selectedItem={selectedItem}
          setSelectedItem={setSelectedItem}
        />
      </>
    )
  );
};

export default CategoryList;
